import { createContext } from 'react';
export const BottomSheetGestureHandlersContext = /*#__PURE__*/createContext(null);
//# sourceMappingURL=gesture.js.map